// extracted by mini-css-extract-plugin
export default {"plansContainer":"Plans_plansContainer__3esoc","textContainer":"Plans_textContainer__7-Ksr","textContainerSpoiler":"Plans_textContainerSpoiler__EnapK"};